import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const products = [
    {
        id: 1,
        cat: "konyha",
        title: "Egyedi konyhabútor",
        wood: "Fa hatású felső elemek, sötét alsó frontok",
        image: "https://customer-assets.emergentagent.com/job_timber-workspace/artifacts/xynarg0a_IMG_4557.jpg",
    },
    {
        id: 2,
        cat: "konyha",
        title: "Konyhai részletmegoldás",
        wood: "Sarok kialakítású munkapult és mosogató",
        image: "https://customer-assets.emergentagent.com/job_timber-workspace/artifacts/kgxqy4k9_IMG_4559.jpg",
    },
    {
        id: 3,
        cat: "egyedi",
        title: "Beépített szekrény",
        wood: "Nyitott és zárt elemek, fa mintázattal",
        image: "https://customer-assets.emergentagent.com/job_timber-workspace/artifacts/r9jnrw1s_IMG_4566.png",
    },
    {
        id: 4,
        cat: "egyedi",
        title: "Nappali tárolórendszer",
        wood: "Nyitott és zárt polcok kombinációja",
        image: "https://customer-assets.emergentagent.com/job_timber-workspace/artifacts/41ki8ybq_IMG_4561.jpg",
    },
    {
        id: 5,
        cat: "iroda",
        title: "Egyedi íróasztal",
        wood: "Fa felület, modern kialakítás",
        image: "https://images.unsplash.com/photo-1586380560607-bf9cf9d54e5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHx3b29kZW4lMjBvZmZpY2UlMjBkZXNrfGVufDB8fHx8MTc3Njg1NDQ4MHww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: 6,
        cat: "iroda",
        title: "Konferenciaasztal",
        wood: "Natúr fa felület, üzleti környezethez",
        image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1400&q=80",
    },
];

const filters = [
    { id: "all", label: "Összes" },
    { id: "konyha", label: "Konyha" },
    { id: "iroda", label: "Iroda" },
    { id: "egyedi", label: "Egyedi" },
];

export default function Products() {
    const [filter, setFilter] = useState("all");
    const list =
        filter === "all" ? products : products.filter((p) => p.cat === filter);

    return (
        <div data-testid="products-page">
            <section className="pt-20 pb-16 md:pt-28 md:pb-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <p className="overline">Termékek</p>
                    <h1 className="font-serif mt-5 text-5xl md:text-7xl lg:text-[96px] leading-[0.95] tracking-tight text-[#2C2724] max-w-4xl">
                        Bútor referenciák —
                        <br />
                        <span className="italic text-[#C98A4B]">
                            válogatás.
                        </span>
                    </h1>
                    <p className="mt-8 text-lg text-[#5C534D] max-w-2xl leading-relaxed">
                        Hatszáznál több elkészült bútor és asztalos
                        projektből válogattunk néhány kedvencet — egyedi
                        konyhabútor, irodabútor és beépített bútor saját
                        műhelyünkből, Pakson.
                    </p>

                    {/* Filter bar */}
                    <div className="mt-12 flex flex-wrap gap-3">
                        {filters.map((f) => (
                            <button
                                key={f.id}
                                data-testid={`filter-${f.id}`}
                                onClick={() => setFilter(f.id)}
                                className={`px-5 py-2.5 text-xs uppercase tracking-[0.2em] border transition-all duration-500 ${
                                    filter === f.id
                                        ? "bg-[#4A3728] text-[#F9F6F0] border-[#4A3728]"
                                        : "bg-transparent text-[#4A3728] border-[#4A3728]/30 hover:border-[#4A3728]"
                                }`}
                            >
                                {f.label}
                            </button>
                        ))}
                    </div>
                </div>
            </section>

            {/* Gallery */}
            <section className="pb-24 md:pb-36">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                        {list.map((p, i) => (
                            <div
                                key={p.id}
                                data-testid={`product-card-${p.id}`}
                                className={`group ${
                                    i % 5 === 0 ? "md:col-span-2" : ""
                                }`}
                            >
                                <div
                                    className={`overflow-hidden relative ${
                                        i % 5 === 0
                                            ? "h-[380px] md:h-[540px]"
                                            : "h-[360px] md:h-[420px]"
                                    }`}
                                >
                                    <img
                                        src={p.image}
                                        alt={`${p.title} — ${p.wood} | BAU-Paks Kft. egyedi asztalosmunka, Paks`}
                                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105"
                                    />
                                </div>
                                <div className="mt-5 flex items-baseline justify-between gap-4">
                                    <div>
                                        <p className="overline text-[#C98A4B]">
                                            {p.cat}
                                        </p>
                                        <h3 className="font-serif text-2xl md:text-3xl mt-2 text-[#2C2724] leading-tight">
                                            {p.title}
                                        </h3>
                                        <p className="mt-1 text-sm text-[#5C534D]">
                                            {p.wood}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {list.length === 0 && (
                        <p
                            data-testid="products-empty"
                            className="text-center text-[#5C534D] py-20"
                        >
                            Ebben a kategóriában még nincs projekt.
                        </p>
                    )}
                </div>
            </section>

            {/* CTA */}
            <section className="bg-[#F3EBE1] py-24 md:py-32">
                <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
                    <p className="overline">Ihletet kapott?</p>
                    <h2 className="font-serif mt-5 text-4xl md:text-6xl leading-tight tracking-tight text-[#2C2724] max-w-3xl mx-auto">
                        Készítsük el az
                        <span className="italic text-[#C98A4B]">
                            {" "}
                            Ön darabját
                        </span>{" "}
                        is.
                    </h2>
                    <Link
                        to="/ajanlatkeres"
                        data-testid="products-cta"
                        className="inline-flex items-center gap-2 mt-10 px-10 py-4 bg-[#4A3728] text-[#F9F6F0] text-sm font-semibold tracking-wide hover:bg-[#2C2724] transition-colors duration-500"
                    >
                        Ajánlatot kérek
                        <ArrowUpRight size={16} />
                    </Link>
                </div>
            </section>
        </div>
    );
}
